import { render, staticRenderFns } from "./AS_HeaderMobile.vue?vue&type=template&id=4cfba953&scoped=true&"
import script from "./AS_HeaderMobile.vue?vue&type=script&scoped=true&lang=js&"
export * from "./AS_HeaderMobile.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./AS_HeaderMobile.vue?vue&type=style&index=0&id=4cfba953&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfba953",
  null
  
)

export default component.exports